import { useCallback, useEffect, useMemo, useState } from 'react'
import useSWR from 'swr'

import { sharedStaticConfig } from '@ngb-frontend/shared/config'
import { BookingStatus } from '@ngb-frontend/shared/types'

import { servicesByServiceCode } from '../service/servicesByServiceCode'

import type {
  Booking,
  BookingServiceCode,
  QueryCountryCode,
  VehicleIdentifier,
} from '@ngb-frontend/shared/types'

export const filterHistoryBySrvCode = (
  serviceCode: BookingServiceCode,
  history?: Booking[],
) => {
  return history?.filter(
    (his) =>
      his.service?.items?.some((i) =>
        servicesByServiceCode[serviceCode].includes(i.code),
      ) &&
      (his.status === BookingStatus.Confirmed ||
        his.status === BookingStatus.Unconfirmed),
  )
}

export const useBookingRequestHistory = (
  getChecked: () => boolean,
  setChecked: (checked: boolean) => void,
  vehicleIdentifier?: VehicleIdentifier,
  serviceCode?: BookingServiceCode,
  countryCode?: QueryCountryCode,
) => {
  const isChecked = getChecked()
  const [hasBeenChecked, setHasBeenChecked] = useState(isChecked)

  const res = useSWR<Booking[]>(
    vehicleIdentifier && countryCode
      ? [
          sharedStaticConfig.apiRoutes.fetchBookingHistory,
          { vehicleIdentifier: vehicleIdentifier, countryCode },
        ]
      : null,
  )

  const markAsChecked = useCallback(() => {
    setChecked(true)
    setHasBeenChecked(true)
  }, [setChecked])

  const filteredData = useMemo(() => {
    return serviceCode
      ? filterHistoryBySrvCode(serviceCode, res.data)
      : res.data
  }, [res.data, serviceCode])

  useEffect(() => {
    setHasBeenChecked(isChecked)
  }, [isChecked])

  const hasData = !!filteredData?.length

  return {
    ...res,
    markAsChecked,
    hasBeenChecked,
    hasData,
    data: filteredData,
  }
}
